import React from "react";
import "../../../../styles/css/common-loader.css";

export default class PlaceHolder extends React.PureComponent {
  render() {
    return (
      <div
        style={{
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
        }}
      >
        <div
          className="newLoader"
          role="progressbar"
          aria-label="Loading products"
        />
      </div>
    );
  }
}
